export default __webpack_public_path__ + "static/media/1846.59239b8a.png";